export const KMC_POPUP_MODE = 'web_popup' as const;
// KMC web sample step02 desktop popup option 기준. Mobile은 feature 없이 전체 화면 전환에 맡긴다.
export const KMC_DESKTOP_POPUP_FEATURES =
  'width=425,height=550,resizable=0,scrollbars=no,status=0,titlebar=0,toolbar=0' as const;

export interface KmcVerifiedMessage {
  kmcResultKey: string;
}

export interface KmcErrorMessage {
  kmcError: string;
}

export type KmcPopupMessage = KmcVerifiedMessage | KmcErrorMessage;

export const createKmcPopupUrl = (redirectUrl: string, baseUrl: string): string => {
  const url = new URL(redirectUrl, baseUrl);
  // kmc 자체 에러를 테스트 해야할 땐 forceError=UNKNOWN 도 param에 추가
  // https://hpcnt.slack.com/archives/C0APJSAHTS9/p1783919338171799?thread_ts=1783919277.537059&cid=C0APJSAHTS9
  url.searchParams.set('mode', KMC_POPUP_MODE);

  return url.toString();
};

export const getKmcExpectedOrigin = (redirectUrl: string, baseUrl: string): string => {
  return new URL(redirectUrl, baseUrl).origin;
};

export const getKmcPopupFeatures = (isMobile?: boolean): string | undefined => {
  return isMobile ? undefined : KMC_DESKTOP_POPUP_FEATURES;
};

export const isKmcVerifiedMessage = (data: unknown): data is KmcVerifiedMessage => {
  if (!data || typeof data !== 'object') return false;

  const { kmcResultKey } = data as Partial<KmcVerifiedMessage>;
  return typeof kmcResultKey === 'string' && kmcResultKey.trim().length > 0;
};

export const isKmcErrorMessage = (data: unknown): data is KmcErrorMessage => {
  if (!data || typeof data !== 'object') return false;

  // popup 내 KMC 자체 에러는 kmcError 필드로 전달된다.
  return 'kmcError' in data && (data as KmcErrorMessage).kmcError != null;
};

export const isKmcPopupMessage = (data: unknown): data is KmcPopupMessage => {
  return isKmcVerifiedMessage(data) || isKmcErrorMessage(data);
};

export const isValidKmcMessageEvent = (
  event: Pick<MessageEvent, 'data' | 'origin' | 'source'>,
  expectedOrigin: string,
  popupWindow: Window | null
): event is MessageEvent<KmcPopupMessage> => {
  return (
    event.origin === expectedOrigin && event.source === popupWindow && isKmcPopupMessage(event.data)
  );
};
